import { PlaceholderList, LinkPlaceholder } from 'app/components/layouts/Sidebar/LinkPlaceholder';
import { findTranslate } from 'app/utils/translate';
import Image from 'app/components/layouts/Image';
import React, { useMemo, Suspense } from 'react';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Blog } from 'types/blog';
import env from '.env.json';

const LazyLink = React.lazy(() => import('next/link'));

const BlogRightLink = ({ blog, language }) => {
  const blogTitle = findTranslate(blog?.translates, 'title', language);
  const image = blog.thumbnail || blog.image;
  const slug = blog[`slug_${language}`];

  return (
    <Suspense fallback={<LinkPlaceholder />}>
      <LazyLink href={`/news/${slug}`}>
        <article className="d-flex mb-3 article-container cursor-pointer">
          <div className="object-fit-cover">
            <Image
              alt=""
              width={80}
              height={60}
              disableAuto
              style={{ objectFit: 'cover' }}
              src={`${env.URL_APP_FILE || env.URL_API}/storage/${image}`}
            />
          </div>
          <div className="content">
            <p className="text-title text-truncate-3 pl-2 mb-0">
              {blogTitle || blog.title}
            </p>
          </div>
        </article>
      </LazyLink>
    </Suspense>
  );
};

const BlogRightContent = ({ title, contentRight }) => {
  const { blogs } = useSelector((state: AppStoreState) => state.global);
  const router = useRouter();

  const blogRightContent = useMemo(() => {
    if (!blogs?.length || title) {
      return <PlaceholderList />;
    }

    return (blogs || []).map((blog: Blog) => (
      <BlogRightLink
        key={blog.id}
        blog={blog}
        language={router.locale}
      />
    ));
  }, [blogs, router.locale]);

  return (
    <div className='px-1'>
      {contentRight || blogRightContent}
    </div>
  );
};

export default BlogRightContent;
